// Module
var code = "<div class=\"br-caption-2\" ng-class=\"[$ctrl.task.status, ($ctrl.small ? 'small' : '')]\" layout-align=\"center center\" layout=\"column\"> <span>{{$ctrl.small ? 'STATUS_TAG.' + $ctrl.task.status : $ctrl.task.status | translate}}</span> <md-tooltip md-delay=\"200\" md-direction=\"top\"> {{$ctrl.task.status | translate}} </md-tooltip> </div> ";
// Exports
export default code;